module.exports = __webpack_public_path__ + "img/研究列表标题.34a83c0e.png";